// ABOUTME: In-app email verification screen — Kratos verification flow (email → code).
// ABOUTME: Multi-step (stayOnSuccess): re-renders the flow so the code field / success message shows.

import { Link, useSearchParams } from "react-router"
import type { UpdateVerificationFlowBody, VerificationFlow } from "@ory/client"
import { useTranslation } from "react-i18next"
import { ory } from "@/model/auth/ory"
import { useKratosFlow } from "@/features/auth/useKratosFlow"
import { FlowForm } from "@/features/auth/FlowForm"
import { AUTH_LINK_CLASS } from "@/features/auth/authStyles"
import { AuthCard } from "./AuthCard"
import { AuthFlowError } from "./AuthFlowError"
import { AuthLoading } from "./AuthLoading"
import { asFlowBody } from "@/features/auth/flowBody"

export const VerificationPage = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get("return_to")

  const { flow, submit, submitting, failed, restart } = useKratosFlow<VerificationFlow>({
    createFlow: () => ory.createBrowserVerificationFlow(),
    getFlow: (id) => ory.getVerificationFlow({ id }),
    updateFlow: (id, body) =>
      ory.updateVerificationFlow({
        flow: id,
        updateVerificationFlowBody: asFlowBody<UpdateVerificationFlowBody>(body),
      }),
    stayOnSuccess: true,
  })

  if (failed)
    return (
      <AuthFlowError
        title={t("auth.checkEmailTitle")}
        onRetry={restart}
      />
    )
  if (!flow) return <AuthLoading />

  return (
    <AuthCard
      title={t("auth.checkEmailTitle")}
      footer={
        <Link
          to={returnTo ? `/auth/login?return_to=${encodeURIComponent(returnTo)}` : "/auth/login"}
          className={AUTH_LINK_CLASS}
        >
          {t("auth.backToLogin")}
        </Link>
      }
    >
      <FlowForm
        flow={flow}
        submitting={submitting}
        onSubmit={submit}
      />
    </AuthCard>
  )
}
